// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3WKgt","input":"styles_input__1-U3d"};